<template>
  <div class="ad-revenue-query">
    <el-card shadow="never" class="animate__animated animate__fadeInUp">
      
      <el-form :inline="true" :model="form" label-width="70px" @submit.native.prevent>
        <div style="display:flex;flex-wrap:wrap;align-items:flex-start;gap:8px;">
          <el-form-item label="时间范围" class="date-range-item">
            <el-date-picker
              v-model="form.dateRange"
              type="datetimerange"
              range-separator="至"
              start-placeholder="开始时间"
              end-placeholder="结束时间"
              align="right"
              :default-time="['00:00:00', '23:59:59']"
              format="yyyy-MM-dd HH:mm:ss"
              value-format="yyyy-MM-dd HH:mm:ss"
              :clearable="true"
              popper-class="date-range-popper"
              style="width:380px;"
            />
          </el-form-item>
          <el-form-item label="广告类型">
            <el-select v-model="form.adType" clearable placeholder="请选择广告类型" style="width:140px;">
              <el-option label="激励视频" value="reward"></el-option>
              <el-option label="Banner" value="banner_main"></el-option>
              <el-option label="插屏全屏" value="interstitial"></el-option>
              <el-option label="签到激励" value="sign_in_reward"></el-option>
              <el-option label="任务激励" value="task_reward"></el-option>
              <el-option label="开屏广告" value="splash"></el-option>
              <el-option label="信息流" value="feed"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="广告平台">
            <el-select v-model="form.adnName" clearable placeholder="请选择广告平台" style="width:130px;">
              <el-option label="优量汇" value="gdt"></el-option>
              <el-option label="快手" value="ks"></el-option>
              <el-option label="穿山甲" value="pangle"></el-option>
              <el-option label="百度" value="baidu"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="用户名">
            <el-input v-model.trim="form.username" clearable placeholder="请输入用户名" style="width:140px;" />
          </el-form-item>
          <el-form-item>
            <div class="button-group" style="display:flex;flex-wrap:wrap;gap:6px;">
              <el-button type="primary" :loading="loading" @click="handleSearch" icon="el-icon-search">查询</el-button>
              <el-button type="success" plain :loading="loading" @click="handleCursorSearch" icon="el-icon-aim">游标查询</el-button>
              <el-button type="info" plain @click="handleReset" :disabled="loading" icon="el-icon-refresh">重置</el-button>
            </div>
          </el-form-item>
        </div>
      </el-form>

      <div v-if="error" class="error">{{ error }}</div>
      <el-empty v-else-if="!loading && !hasTable" description="暂无数据" />
      <div v-else>
        <div class="summary-bar">
          <el-row :gutter="12" type="flex" justify="center">
            <el-col :span="4">
              <el-card class="summary-card card-total animate__animated animate__fadeInUp">
                <div class="summary-content">
                  <i class="el-icon-wallet summary-icon"></i>
                  <div class="summary-value">{{ totalEcpmDisplay }}</div>
                  <div class="summary-label">总收益</div>
                </div>
              </el-card>
            </el-col>
            <el-col :span="4">
              <el-card class="summary-card card-banner animate__animated animate__fadeInUp">
                <div class="summary-content">
                  <i class="el-icon-s-data summary-icon"></i>
                  <div class="summary-value">{{ gdtEcpm }}</div>
                  <div class="summary-label">优量汇收益</div>
                </div>
              </el-card>
            </el-col>
            <el-col :span="4">
              <el-card class="summary-card card-interstitial animate__animated animate__fadeInUp">
                <div class="summary-content">
                  <i class="el-icon-video-play summary-icon"></i>
                  <div class="summary-value">{{ ksEcpm }}</div>
                  <div class="summary-label">快手收益</div>
                </div>
              </el-card>
            </el-col>
            <el-col :span="4">
              <el-card class="summary-card card-splash animate__animated animate__fadeInUp">
                <div class="summary-content">
                  <i class="el-icon-connection summary-icon"></i>
                  <div class="summary-value">{{ pangleEcpm }}</div>
                  <div class="summary-label">穿山甲收益</div>
                </div>
              </el-card>
            </el-col>
            <el-col :span="4">
              <el-card class="summary-card card-reward animate__animated animate__fadeInUp">
                <div class="summary-content">
                  <i class="el-icon-search summary-icon"></i>
                  <div class="summary-value">{{ baiduEcpm }}</div>
                  <div class="summary-label">百度收益</div>
                </div>
              </el-card>
            </el-col>
            <el-col v-if="hasOtherPlatformSummary" :span="4">
              <el-card class="summary-card card-other animate__animated animate__fadeInUp">
                <div class="summary-content">
                  <i class="el-icon-warning-outline summary-icon"></i>
                  <div class="summary-value">{{ otherEcpm }}</div>
                  <div class="summary-label">其他收益</div>
                </div>
              </el-card>
            </el-col>
            <el-col :span="4">
              <el-card class="summary-card card-count animate__animated animate__fadeInUp">
                <div class="summary-content">
                  <i class="el-icon-document summary-icon"></i>
                  <div class="summary-value">{{ summaryTotalCount }}</div>
                  <div class="summary-label">总条数</div>
                </div>
              </el-card>
            </el-col>
          </el-row>
        </div>
        
        
        <el-table
          :data="tableData"
          border
          stripe
          v-loading="loading"
          element-loading-text="正在查询..."
          class="animate__animated animate__fadeIn"
        >
          <el-table-column prop="id" label="ID" width="90" align="center"/>
          <el-table-column prop="username" label="用户名" min-width="120" />
          <el-table-column prop="adnName" label="广告平台" min-width="120" :formatter="adnNameFormatter" />
          <el-table-column prop="adType" label="广告类型" min-width="100" :formatter="adTypeFormatter" />
          <el-table-column prop="ecpm" label="收益" min-width="100" :formatter="ecpmFormatter" />
          <el-table-column
            prop="createdTime"
            label="创建时间"
            min-width="170"
            :formatter="timeFormatter"
          />
        </el-table>
        
        <!-- 分页组件 -->
        <div class="pagination-container">
          <el-pagination
            v-if="!isCursorMode"
            background
            layout="total, sizes, prev, pager, next, jumper"
            :current-page="pagination.pageNum"
            :page-size="pagination.pageSize"
            :page-sizes="[10, 20, 50, 100]"
            :total="pagination.total"
            @current-change="handleCurrentChange"
            @size-change="handleSizeChange"
          />
          <div v-else class="cursor-pagination">
            <el-button 
              type="primary" 
              :loading="loading" 
              :disabled="!hasNext" 
              @click="fetchDataByCursor"
            >
              {{ hasNext ? '加载更多' : '没有更多数据了' }}
            </el-button>
            <span class="cursor-info">当前游标 ID: {{ cursorId || '无' }}</span>
          </div>
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
import { request } from '@/utils/http.js'

const KNOWN_ADN_CODES = ['gdt', 'ks', 'pangle', 'baidu']
const ADN_NAME_MAP = {
  gdt: '优量汇',
  ks: '快手',
  pangle: '穿山甲',
  baidu: '百度'
}

export default {
  name: 'AdRevenueQuery',
  data() {
    const { start, end } = this.getTodayStartEnd();
    return {
      form: {
        dateRange: [start, end],
        username: '',
        adType: '',
        adnName: ''
      },
      loading: false,
      error: '',
      response: null,
      tableData: [],
      // 分页参数
      pagination: {
        pageNum: 1,
        pageSize: 10,
        total: 0
      },
      // 添加后端返回的总计数据
      totalCount: 0,
      totalEcpm: 0,
      platformSummary: [],
      // 游标分页相关
      isCursorMode: false,
      cursorId: null,
      hasNext: false
    }
  },
  computed: {
    hasTable() {
      return Array.isArray(this.tableData) && this.tableData.length > 0
    },
    totalEcpmDisplay() {
      const sum = this.platformSummary.reduce((acc, item) => acc + (Number(item.total_ecpm) || 0), 0)
      return this.formatEcpm(sum)
    },
    summaryTotalCount() {
      return this.platformSummary.reduce((acc, item) => acc + (Number(item.record_count) || 0), 0)
    },
    gdtEcpm() {
      return this.calcSummaryAdnEcpm('gdt')
    },
    ksEcpm() {
      return this.calcSummaryAdnEcpm('ks')
    },
    pangleEcpm() {
      return this.calcSummaryAdnEcpm('pangle')
    },
    baiduEcpm() {
      return this.calcSummaryAdnEcpm('baidu')
    },
    otherPlatformSummary() {
      return this.platformSummary.filter(item => !KNOWN_ADN_CODES.includes(item.adn_name))
    },
    hasOtherPlatformSummary() {
      return this.otherPlatformSummary.length > 0
    },
    otherEcpm() {
      const sum = this.otherPlatformSummary.reduce((acc, item) => acc + (Number(item.total_ecpm) || 0), 0)
      return this.formatEcpm(sum)
    }
  },
  methods: {
    pad2(n) {
      return n.toString().padStart(2, '0')
    },
    getTodayStartEnd() {
      const now = new Date()
      const tomorrow = new Date(now.getTime() + 24 * 60 * 60 * 1000)
      const y = now.getFullYear()
      const m = this.pad2(now.getMonth() + 1)
      const d = this.pad2(now.getDate())
      const tomorrowY = tomorrow.getFullYear()
      const tomorrowM = this.pad2(tomorrow.getMonth() + 1)
      const tomorrowD = this.pad2(tomorrow.getDate())
      const start = `${y}-${m}-${d} 00:00:00`
      const end = `${tomorrowY}-${tomorrowM}-${tomorrowD} 00:00:00`
      return { start, end }
    },
    pretty(obj) {
      try {
        return JSON.stringify(obj, null, 2)
      } catch (e) {
        return String(obj)
      }
    },
    timeFormatter(row, column, cellValue) {
      if (!cellValue) return ''
      return String(cellValue).replace('T', ' ')
    },
    boolFormatter(row, column, cellValue) {
      return cellValue ? '是' : '否'
    },
    adnNameFormatter(row, column, cellValue) {
      return ADN_NAME_MAP[cellValue] || cellValue || '-'
    },
    adTypeFormatter(row, column, cellValue) {
      const adTypeMap = {
        'reward': '激励视频',
        'banner_main': 'Banner',
        'interstitial': '插屏全屏',
        'sign_in_reward': '签到激励',
        'task_reward': '任务激励',
        'splash': '开屏广告',
        'feed': '信息流'
      }
      return adTypeMap[cellValue] || cellValue || '-'
    },
    ecpmFormatter(row, column, cellValue) {
      // 将 ecpm 值缩小十万倍（10万ecpm = 1元）
      const value = Number(cellValue) || 0;
      return (value / 100000).toFixed(6);
    },
    formatEcpm(value) {
      return (Number(value) / 100000).toFixed(6)
    },
    getPlatformSummaryItem(code) {
      return this.platformSummary.find(item => item.adn_name === code) || null
    },
    calcSummaryAdnEcpm(code) {
      const item = this.getPlatformSummaryItem(code)
      return this.formatEcpm(item ? item.total_ecpm : 0)
    },
    async fetchSummaryData() {
      const [start, end] = this.form.dateRange || []
      const params = new URLSearchParams()
      if (start && end) {
        params.append('startDate', start)
        params.append('endDate', end)
      }
      if (this.form.username) {
        params.append('username', this.form.username)
      }
      if (this.form.adType) {
        params.append('adType', this.form.adType)
      }
      if (this.form.adnName) {
        params.append('adnName', this.form.adnName)
      }
      const queryString = params.toString()
      let url = `/admin/ADRevenueDataAdmin/getADRevenueDataOnlyByDate`
      if (queryString) {
        url += `?${queryString}`
      }
      try {
        const result = await request(url, { method: 'GET' })
        if (result && result.code === 200 && result.data) {
          this.platformSummary = Array.isArray(result.data) ? result.data : []
        } else {
          this.platformSummary = []
        }
      } catch (e) {
        this.platformSummary = []
      }
    },
    handleReset() {
      this.form.dateRange = []
      this.form.username = ''
      this.form.adType = ''
      this.form.adnName = ''
      this.tableData = []
      this.response = null
      this.error = ''
      // 重置分页参数
      this.pagination = {
        pageNum: 1,
        pageSize: 10,
        total: 0
      }
      // 重置总计数据
      this.totalCount = 0
      this.totalEcpm = 0
      this.platformSummary = []
      // 重置游标状态
      this.isCursorMode = false
      this.cursorId = null
      this.hasNext = false
      // 清空图表
      if (this.chartInstance) {
        this.chartInstance.dispose();
        this.chartInstance = null;
      }
    },
    handleCurrentChange(page) {
      this.pagination.pageNum = page;
      this.fetchData(false);
    },
    handleSizeChange(size) {
      this.pagination.pageSize = size;
      this.pagination.pageNum = 1; // 重置到第一页
      this.fetchData();
    },
    async handleSearch() {
      this.isCursorMode = false;
      this.pagination.pageNum = 1;
      this.tableData = []
      this.totalCount = 0
      this.totalEcpm = 0
      this.fetchSummaryData()
      await this.fetchData()
    },
    async handleCursorSearch() {
      this.isCursorMode = true;
      this.cursorId = null;
      this.tableData = [];
      this.totalCount = 0;
      this.totalEcpm = 0;
      this.fetchSummaryData()
      await this.fetchDataByCursor();
    },
    async fetchDataByCursor() {
      this.error = ''
      this.loading = true
      
      try {
        // 构建参数：cursorId 和 pageSize
        const pageSize = this.pagination.pageSize;
        let url = `/admin/ADRevenueDataAdmin/getADRevenueDataByCursor?pageSize=${pageSize}`;
        if (this.cursorId !== null) {
          url += `&cursorId=${this.cursorId}`;
        }

        const result = await request(url, {
          method: 'GET'
        })

        if (result && result.code === 200 && result.data) {
          const { records, hasNext, nextCursorId } = result.data;
          
          // 追加数据
          this.tableData = [...this.tableData, ...(records || [])];
          this.hasNext = !!hasNext;
          this.cursorId = nextCursorId;
          
          // 更新统计（游标分页通常不返回总计，这里累加当前已加载的）
          this.totalCount = this.tableData.length;
          // 10万ecpm = 1元，进行换算
          this.totalEcpm = this.tableData.reduce((sum, item) => sum + (Number(item.ecpm) || 0) / 100000, 0);
        } else {
          this.$message.error(result.msg || '游标查询失败');
        }
      } catch (e) {
        this.error = e.message || '请求出现错误'
      } finally {
        this.loading = false
      }
    },
    async fetchData() {
      this.error = ''
      this.response = null

      const [start, end] = this.form.dateRange || []
      
      if (start && end && new Date(end.replace(' ', 'T')) < new Date(start.replace(' ', 'T'))) {
        this.error = '结束日期不能早于开始日期'
        return
      }

      // 构建URL参数
      let url = `/admin/ADRevenueDataAdmin/getADRevenueDataByDateRange?pageNum=${this.pagination.pageNum}&pageSize=${this.pagination.pageSize}`;
      
      if (start && end) {
        url += `&startDate=${encodeURIComponent(start)}&endDate=${encodeURIComponent(end)}`;
      }
      
      // 如果有广告类型筛选，则添加到URL参数中
      if (this.form.adType) {
        url += `&adType=${encodeURIComponent(this.form.adType)}`;
      }
      
      // 如果有广告平台筛选，则添加到URL参数中
      if (this.form.adnName) {
        url += `&adnName=${encodeURIComponent(this.form.adnName)}`;
      }
      
      // 如果有用户名，则添加到请求体中
      const body = this.form.username ? { username: this.form.username } : {};

      this.loading = true
      try {
        // 发送POST请求，参数在URL中，可选的username在请求体中
        const result = await request(url, {
          method: 'POST',
          body: JSON.stringify(body)
        })
        
        // 处理返回的数据
        if (result && typeof result === 'object' && result.data) {
          const data = result.data
          const newRecords = Array.isArray(data.records) ? data.records : []
          
          // 设置表格数据
          this.tableData = newRecords
          
          // 更新分页信息
          this.pagination.total = data.total || 0
          this.pagination.pageSize = data.size || this.pagination.pageSize
          this.pagination.pageNum = data.current || this.pagination.pageNum
          
          // 使用后端返回的总计数据
          this.totalCount = data.total_count || 0
          this.totalEcpm = data.total_ecpm || 0
        } else {
          this.tableData = []
          this.pagination.total = 0
          this.pagination.pageNum = 1
          // 重置总计数据
          this.totalCount = 0
          this.totalEcpm = 0
        }
      } catch (e) {
        this.error = e && e.message ? e.message : '请求出现错误'
      } finally {
        this.loading = false
      }
    },
  },
  created() {
    // 移除默认时间范围
  },
  mounted() {
    // 页面加载完成后自动执行一次搜索
    this.handleSearch();
  },
}
</script>

<style scoped>
.ad-revenue-query {
}

.search-form {
  margin-bottom: 16px;
}

.query-form-container {
  width: 100%;
}

.full-width {
  width: 100%;
}

.form-item-compact {
  margin-bottom: 0;
}

.form-item-compact ::v-deep .el-form-item__label {
  padding-right: 6px;
  font-size: 13px;
}

.form-item-compact ::v-deep .el-form-item__content {
  margin-left: 70px !important;
}

.button-group {
  display: flex;
  gap: 8px;
  white-space: nowrap;
}

.button-group .el-button {
  margin-left: 0;
  padding: 7px 12px;
}

.summary-card {
  border-radius: 10px;
  overflow: hidden;
  transition: transform 0.3s ease;
  height: 100px;
  box-shadow: 0 4px 8px rgba(0,0,0,0.05);
}

.summary-card:hover {
  transform: translateY(-3px);
  box-shadow: 0 6px 12px rgba(0,0,0,0.1);
}

.summary-card.card-total {
  background: linear-gradient(135deg, #409EFF, #337ECC);
  color: #fff;
  border: none;
}

.summary-card.card-banner {
  background: linear-gradient(135deg, #E6A23C, #C78C2E);
  color: #fff;
  border: none;
}

.summary-card.card-interstitial {
  background: linear-gradient(135deg, #9B59B6, #7D3C98);
  color: #fff;
  border: none;
}

.summary-card.card-splash {
  background: linear-gradient(135deg, #20B2AA, #178F89);
  color: #fff;
  border: none;
}

.summary-card.card-reward {
  background: linear-gradient(135deg, #F56C6C, #D95454);
  color: #fff;
  border: none;
}

.summary-card.card-other {
  background: linear-gradient(135deg, #909399, #73767A);
  color: #fff;
  border: none;
}

.summary-card.card-count {
  background: linear-gradient(135deg, #67C23A, #529B2E);
  color: #fff;
  border: none;
}

/* Date range picker panel — always below & responsive */
.date-range-item {
  position: relative;
}

@media (max-width: 767px) {
  .date-range-item ::v-deep .el-date-range-picker {
    width: 100%;
    min-width: auto;
  }
  .date-range-item ::v-deep .el-picker-panel__body {
    min-width: auto;
  }
  .date-range-item ::v-deep .el-picker-panel__content {
    margin: 0;
  }
  .date-range-item ::v-deep .el-date-range-picker__header {
    padding: 8px;
  }
  .date-range-item ::v-deep .el-date-table {
    width: 100%;
  }
}

.summary-content {
  text-align: center;
  /* padding: 18px; */
}

.summary-icon {
  font-size: 20px;
  margin-bottom: 4px;
  display: block;
  color: inherit;
}

.summary-value {
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 2px;
}

.summary-label {
  font-size: 11px;
  opacity: 0.85;
  font-weight: normal;
}

.summary-bar {
  margin-bottom: 30px;
}

.error {
  color: #f87171;
  background: rgba(239, 68, 68, 0.15);
  border: 1px solid rgba(239, 68, 68, 0.3);
  padding: 8px 10px;
  border-radius: 6px;
  margin-bottom: 12px;
}

.pagination-container {
  margin-top: 24px;
  display: flex;
  justify-content: flex-end;
}

.cursor-pagination {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
}

.cursor-info {
  font-size: 12px;
  color: #909399;
}

/* Speed up animations */
.el-card.animate__animated,
.el-table.animate__animated {
  --animate-duration: 0.3s;
}

.ad-revenue-query ::v-deep .el-table th,
.ad-revenue-query ::v-deep .el-table th.is-leaf {
  background-color: #D6E4FF;
}
</style>